var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4555 14.9093C21.4555 15.054 21.4277 15.1909 21.3877 15.3213L15.0396 8.49344L21.4555 3.50334V14.9093ZM2.60429 16.2965L9.03723 9.44155L11.4753 11.2843L13.8078 9.43015L20.3462 16.2965C20.2443 16.3201 2.70623 16.3201 2.60429 16.2965ZM1.49506 14.9093V3.50334L7.9109 8.49344L1.56279 15.3213C1.52287 15.1909 1.49506 15.054 1.49506 14.9093ZM20.7426 2.0776L11.4753 9.20631L2.20793 2.0776H20.7426ZM20.0297 0.651855H2.92081C1.34607 0.651855 0.0693207 1.92861 0.0693207 3.50334V14.9093C0.0693207 16.484 1.34607 17.7608 2.92081 17.7608H20.0297C21.6045 17.7608 22.8812 16.484 22.8812 14.9093V3.50334C22.8812 1.92861 21.6045 0.651855 20.0297 0.651855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogo);
export default __webpack_public_path__ + "static/media/email-logo.5c7193b53dc9d9e9a92fb2f66715f9db.svg";
export { ForwardRef as ReactComponent };